import { jsx as _jsx } from "react/jsx-runtime";
// Modal / Sheet — оверлейный контейнер (пикер эмодзи, карточки, диалоги).
// desktop → центрированная карточка (Modal); mobile → нижняя шторка (Sheet). Закрытие — useDismiss
// (Esc / клик по фону). Презентационный: open/onClose управляются снаружи.
import { useRef } from 'react';
import { useDismiss } from './useDismiss.js';
const backdrop = {
    position: 'fixed',
    inset: 0,
    background: 'var(--color-overlay)',
    display: 'flex',
    zIndex: 'var(--z-sheet)',
};
export function Modal({ open, onClose, children, label }) {
    const panel = useRef(null);
    useDismiss({ open, onClose, ref: panel });
    if (!open)
        return null;
    const center = { ...backdrop, alignItems: 'center', justifyContent: 'center' };
    const card = {
        maxWidth: 'min(92vw, 480px)',
        maxHeight: '86vh',
        overflow: 'auto',
        background: 'var(--color-surface)',
        color: 'var(--color-text)',
        borderRadius: 'var(--radius-card)',
        boxShadow: 'var(--shadow-menu)',
        padding: 'var(--space-4)',
    };
    return (_jsx("div", { "data-modal-backdrop": "", style: center, children: _jsx("div", { ref: panel, role: "dialog", "aria-modal": "true", "aria-label": label, "data-modal": "", style: card, children: children }) }));
}
export function Sheet({ open, onClose, children, label }) {
    const panel = useRef(null);
    useDismiss({ open, onClose, ref: panel });
    if (!open)
        return null;
    const bottom = { ...backdrop, alignItems: 'flex-end', justifyContent: 'center' };
    const card = {
        width: '100%',
        maxHeight: '80vh',
        overflow: 'auto',
        background: 'var(--color-surface)',
        color: 'var(--color-text)',
        borderTopLeftRadius: 'var(--radius-card)',
        borderTopRightRadius: 'var(--radius-card)',
        boxShadow: 'var(--shadow-menu)',
        padding: 'var(--space-4)',
        animation: `tc-ds-sheet-up var(--motion-normal) var(--ease-decelerate)`,
    };
    return (_jsx("div", { "data-sheet-backdrop": "", style: bottom, children: _jsx("div", { ref: panel, role: "dialog", "aria-modal": "true", "aria-label": label, "data-sheet": "", style: card, children: children }) }));
}
//# sourceMappingURL=Modal.js.map